module.exports = __webpack_public_path__ + "static/media/background03.e0343187.jpg";